import React from 'react'

import RecordDetails from '../../../components/RecordDetails'
import ConnectionDetails from './ConnectionDetails'
import StreamSettings from './StreamSettings'

function MySqlForm() {
  return (
    <>
      <ConnectionDetails />
      <RecordDetails name='settings.mysql' />
      <StreamSettings />
    </>
  )
}

export default MySqlForm
